import { Link as ChakraLink, LinkProps } from '@chakra-ui/react';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from '../Icon';

export const Link = (props: LinkProps) => {
  const { children, href, isExternal = true } = props;

  return (
    <ChakraLink href={href} isExternal={isExternal} rel={isExternal ? 'noopener noreferrer' : undefined}>
      {children}

      {isExternal ? <Icon icon={faExternalLink} iconProps={{ fixedWidth: true, size: 'xs' }} mx={1} /> : null}
    </ChakraLink>
  );
};
